exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1xmbOnCWuKLy5LFOomkzGp>div{padding:0;margin-bottom:20px}._2-OUBGxxpKnQ5jX_n39WBm{margin-bottom:20px;color:#666}._3f4_vJ-5Fn1mBaWEcCifPY{padding:30px;background:#f9f9f9}._3f4_vJ-5Fn1mBaWEcCifPY input,._3f4_vJ-5Fn1mBaWEcCifPY select{background:transparent}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/molecules/SubscribedList/style.css"],"names":[],"mappings":"AACA,6BACI,UAAU,AACV,kBAAoB,CACvB,AACD,yBACI,mBAAmB,AACnB,UAAc,CACjB,AACD,yBACI,aAAa,AACb,kBAAmB,CACtB,AACD,+DACI,sBAAwB,CAC3B","file":"style.css","sourcesContent":["\n.listwrap > div{\n    padding:0;\n    margin-bottom: 20px;\n}\n.list{\n    margin-bottom:20px;\n    color:#666666;\n}\n.formwrap{\n    padding:30px;\n    background:#F9F9F9;\n}\n.formwrap select, .formwrap input{\n    background: transparent;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"listwrap": "_1xmbOnCWuKLy5LFOomkzGp",
	"list": "_2-OUBGxxpKnQ5jX_n39WBm",
	"formwrap": "_3f4_vJ-5Fn1mBaWEcCifPY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/molecules/SubscribedList/style.css
// module id = 1034
// module chunks = 0 1 2 3